import { DirectionalHint } from '@fluentui/react'

export default DirectionalHint